/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentSucceededReceiptContent } from './PaymentSucceededReceiptContent';
import {
    PaymentSucceededReceiptContentFromJSON,
    PaymentSucceededReceiptContentFromJSONTyped,
    PaymentSucceededReceiptContentToJSON,
    PaymentSucceededReceiptContentToJSONTyped,
} from './PaymentSucceededReceiptContent';

/**
 * 
 * @export
 * @interface PaymentSucceededReceiptPayload
 */
export interface PaymentSucceededReceiptPayload {
    /**
     * 
     * @type {Array<PaymentSucceededReceiptContent>}
     * @memberof PaymentSucceededReceiptPayload
     */
    customerReceipt: Array<PaymentSucceededReceiptContent>;
    /**
     * 
     * @type {Array<PaymentSucceededReceiptContent>}
     * @memberof PaymentSucceededReceiptPayload
     */
    merchantReceipt: Array<PaymentSucceededReceiptContent>;
}

/**
 * Check if a given object implements the PaymentSucceededReceiptPayload interface.
 */
export function instanceOfPaymentSucceededReceiptPayload(value: object): value is PaymentSucceededReceiptPayload {
    if (!('customerReceipt' in value) || value['customerReceipt'] === undefined) return false;
    if (!('merchantReceipt' in value) || value['merchantReceipt'] === undefined) return false;
    return true;
}

export function PaymentSucceededReceiptPayloadFromJSON(json: any): PaymentSucceededReceiptPayload {
    return PaymentSucceededReceiptPayloadFromJSONTyped(json, false);
}

export function PaymentSucceededReceiptPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentSucceededReceiptPayload {
    if (json == null) {
        return json;
    }
    return {
        
        'customerReceipt': ((json['customerReceipt'] as Array<any>).map(PaymentSucceededReceiptContentFromJSON)),
        'merchantReceipt': ((json['merchantReceipt'] as Array<any>).map(PaymentSucceededReceiptContentFromJSON)),
    };
}

export function PaymentSucceededReceiptPayloadToJSON(json: any): PaymentSucceededReceiptPayload {
    return PaymentSucceededReceiptPayloadToJSONTyped(json, false);
}

export function PaymentSucceededReceiptPayloadToJSONTyped(value?: PaymentSucceededReceiptPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customerReceipt': ((value['customerReceipt'] as Array<any>).map(PaymentSucceededReceiptContentToJSON)),
        'merchantReceipt': ((value['merchantReceipt'] as Array<any>).map(PaymentSucceededReceiptContentToJSON)),
    };
}

